import {useMerchant, useProfile} from '../../hooks';
import {Fragment, useState} from 'react';
import {Spinner, MerchantSelector} from '../../components';
import {MerchantForm, MerchantDialog} from './ui';

export const MerchantPage = () => {
  const merchant = useMerchant();
  const profile = useProfile();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const canCreateMerchant = profile && profile.permissions.includes('merchant.create');

  return (
      <Fragment>
          <h1 className="mb-4 text-4xl w-4/5 text-brand-6 font-bold flex justify-between">
              <span>Merchant</span>
              <div className="flex items-center gap-2">
                  <MerchantSelector />
                  {canCreateMerchant && <button
                      className="flex flex-center h-10 p-2 text-white active:bg-brand-1/25 rounded-lg text-sm bg-brand-1 "
                      onClick={() => setIsDialogOpen(true)}>
                      New Merchant
                  </button>}
              </div>
          </h1>
          <div className="p-7 w-4/5 bg-white rounded-3xl h-full relative">
              {merchant
                  ? <MerchantForm merchant={merchant}/>
                  : <Spinner/>
              }
          </div>
          {isDialogOpen && canCreateMerchant &&
              <MerchantDialog isOpen={isDialogOpen} onClose={() => setIsDialogOpen(false)}/>}
      </Fragment>
  );
};

